.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: visible;
  justify-content: flex-start;

  .mdr-option-selector {
    padding: 7px 8px 7px 0;
    margin-top: auto;
    margin-bottom: auto;
  }

  .dropdown-container {
    display: flex;
    max-width: 490px;

    &:not([stacked]) {
      flex-direction: row;
      justify-content: space-between;
      height: 32px;
      align-items: center;
    }

    &[stacked] {
      flex-direction: column;
      align-items: flex-start;

      gz-form-field {
        margin-left: 26px;
      }
    }
  }

  .selector-form-field {
    max-width: 480px;
    height: 100%;
  }

  #self-form-field {
    max-width: 490px !important;

    &[stacked] {
      margin-bottom: calc(var(--spacer) * 2);
    }
  }
}
